import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface FakeDocument {
  id: string;
  name: string;
  type: string;
  uploadDate: Date;
  size?: string;
}

@Component({
  selector: 'app-modal-select-documents',
  templateUrl: './modal-select-documents.component.html',
  styleUrls: ['./modal-select-documents.component.scss']
})
export class ModalSelectDocumentsComponent implements OnInit {

  availableDocuments: FakeDocument[] = [];
  selectedDocuments: FakeDocument[] = [];
  displayedColumns: string[] = ['select', 'name', 'type', 'size', 'uploadDate'];

  constructor(
    public dialogRef: MatDialogRef<ModalSelectDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    // Initialize with some fake documents
    this.initializeFakeDocuments();

    // Load previously selected documents if any
    if (this.data && this.data.selectedDocuments) {
      this.selectedDocuments = [...this.data.selectedDocuments];
    }
  }

  private initializeFakeDocuments(): void {
    this.availableDocuments = [
      {
        id: '1',
        name: 'Studio SBRT vs Terapia Sistemica',
        type: 'PDF',
        uploadDate: new Date('2024-01-15'),
        size: '2.3 MB'
      },
      {
        id: '2',
        name: 'Meta-analisi Radioterapia Stereotassica',
        type: 'PDF',
        uploadDate: new Date('2024-02-10'),
        size: '1.8 MB'
      },
      {
        id: '3',
        name: 'Efficacia SBRT nel Carcinoma Mammario',
        type: 'PubMed',
        uploadDate: new Date('2024-01-28'),
        size: 'Online'
      }
    ];
  }

  toggleDocumentSelection(document: FakeDocument): void {
    const index = this.selectedDocuments.findIndex(doc => doc.id === document.id);

    if (index > -1) {
      this.selectedDocuments.splice(index, 1);
    } else {
      this.selectedDocuments.push(document);
    }
  }

  isDocumentSelected(document: FakeDocument): boolean {
    return this.selectedDocuments.some(doc => doc.id === document.id);
  }


  getDocumentIcon(type: string): string {
    switch (type) {
      case 'PDF':
        return 'picture_as_pdf';
      case 'DOCX':
        return 'description';
      case 'TXT':
        return 'text_snippet';
      case 'PubMed':
        return 'article';
      default:
        return 'insert_drive_file';
    }
  }

  getDocumentIconColor(type: string): string {
    switch (type) {
      case 'PDF':
        return 'text-danger';
      case 'DOCX':
        return 'text-primary';
      case 'TXT':
        return 'text-secondary';
      case 'PubMed':
        return 'text-success';
      default:
        return 'text-muted';
    }
  }

  selectAll(): void {
    this.selectedDocuments = [...this.availableDocuments];
  }

  clearSelection(): void {
    this.selectedDocuments = [];
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  confirmSelection(): void {
    this.dialogRef.close({
      selectedDocuments: this.selectedDocuments
    });
  }
}